import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Modal from "@/components/modal/Modal";
import React, { useState } from "react";
import { PreviewModal, PreviewTitle } from "../styles/ProductDetail.style";
import { useModal } from "src/utils/overlay";
import getPreviewImage from "../utils/getPreviewImage";
const ProductPreviewModal = (props)=>{
    const { product  } = props;
    const previewImages = getPreviewImage(product);
    const totalPage = previewImages.length + 1;
    const [defaultImage, setDefaultImage] = useState({
        url: product.thumb_img,
        page: 1
    });
    const [isPreviewOpen, { close: closePreviewModal  }] = useModal("preview-modal");
    return /*#__PURE__*/ _jsx(Modal, {
        depth: 1,
        onClose: closePreviewModal,
        open: isPreviewOpen,
        title: /*#__PURE__*/ _jsxs(PreviewTitle, {
            children: [
                product.title,
                " 미리보기",
                " ",
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        defaultImage.page,
                        "/",
                        totalPage
                    ]
                })
            ]
        }),
        name: "preview",
        children: /*#__PURE__*/ _jsxs(PreviewModal, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "navigator",
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                className: defaultImage.url === product.thumb_img ? "active" : "",
                                onClick: ()=>setDefaultImage({
                                        url: product.thumb_img,
                                        page: 1
                                    }),
                                style: {
                                    backgroundImage: "url(".concat(product.thumb_img, ")")
                                }
                            }),
                            /*#__PURE__*/ _jsx(_Fragment, {
                                children: previewImages.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("button", {
                                        className: defaultImage.url === item.url ? "active" : "",
                                        onClick: ()=>setDefaultImage({
                                                url: item.url,
                                                page: index + 2
                                            }),
                                        style: {
                                            backgroundImage: "url(".concat(item.url, ")")
                                        }
                                    }, "preview-image" + index);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "zoom",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "zoom-image",
                        style: {
                            backgroundImage: "url(".concat(defaultImage.url, ")")
                        }
                    })
                })
            ]
        })
    });
};
export default ProductPreviewModal;
